import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
import { format as formatDate, isDate } from 'date-fns';
import { enIN as en, nl } from 'date-fns/locale';

const locales = { en, nl };
i18n
    // i18next-http-backend
    // loads translations from your server
    // https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    // .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: true,
        fallbackLng: 'nl',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default

            format: (value, format, lng) => {
                if (isDate(value)) {
                    const locale = locales[lng];
                    if (format === 'dayMonth') {
                        if (lng === 'en') {
                            return `${formatDate(value, 'MMM', {
                                locale,
                            })} ${formatDate(value, 'd', { locale })}`;
                        }
                        return `${formatDate(value, 'd', {
                            locale,
                        })} ${formatDate(value, 'MMM', { locale })}`;
                    }
                    return formatDate(value, format, { locale });
                }
            },
        },
        backend: {
            // for all available options read the backend's repository readme file
            loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
        },
    });

export default i18n;
